import navigate from '@/locale/en-US/navigate';
import common from './common';

export default {
  首页: 'Home',
  我的: 'Mine',
  消息: 'Message',
  市场: 'Shop',
  动态: 'Dynamic',
  代发车: 'ShopCart',
  工作台: 'Workbench',
  找货: 'Shop',

  ...navigate,
  ...common,

};
